
import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator'

@Component({
  components: {}
})
export default class extends Vue {
  @Prop({ required: true }) visible: boolean

  @Emit('closed')
  onClosed() {}

  @Emit('close')
  onClose() {}

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
